module.exports = __webpack_public_path__ + "img/xcx.19299481.jpg";